// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Ouroboros_Models_Brands_ErrorMessageText from "../Ouroboros.Models.Brands.ErrorMessageText/index.js";
import * as Ouroboros_Models_Brands_HttpStatusCode from "../Ouroboros.Models.Brands.HttpStatusCode/index.js";
import * as Ouroboros_Models_Brands_JwtStatus from "../Ouroboros.Models.Brands.JwtStatus/index.js";
import * as Ouroboros_Models_Brands_JwtSubscriptionStatus from "../Ouroboros.Models.Brands.JwtSubscriptionStatus/index.js";
import * as Ouroboros_Models_Core_Ok from "../Ouroboros.Models.Core.Ok/index.js";
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Programs_TsBridgeHelpers from "../Ouroboros.Programs.TsBridgeHelpers/index.js";
import * as Ouroboros_Services_Clients_Interop_IO from "../Ouroboros.Services.Clients.Interop.IO/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
import * as Ouroboros_Services_Clients_Interop_Task from "../Ouroboros.Services.Clients.Interop.Task/index.js";
import * as Ouroboros_Services_Clients_Interop_TaskEither from "../Ouroboros.Services.Clients.Interop.TaskEither/index.js";
import * as Ouroboros_Services_Clients_Interop_Types from "../Ouroboros.Services.Clients.Interop.Types/index.js";
import * as TsBridge_Class from "../TsBridge.Class/index.js";
import * as TsBridge_DefaultImpls from "../TsBridge.DefaultImpls/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(TsBridge_Monad.bindTsBridgeM);
var tsBridgeRecord1 = /* #__PURE__ */ TsBridge_DefaultImpls.tsBridgeRecord1();
var tsBridge = /* #__PURE__ */ TsBridge_Class.tsBridge(/* #__PURE__ */ Ouroboros_Services_Clients_Interop_Types.tsBridgeIOts(/* #__PURE__ */ Ouroboros_Services_Clients_Interop_Types.tsBridgeOptionTs(/* #__PURE__ */ Ouroboros_Programs_Capabilities.tsBridgeRefreshIntent(/* #__PURE__ */ TsBridge_Class.tsBridgeRecord(/* #__PURE__ */ tsBridgeRecord1(/* #__PURE__ */ TsBridge_DefaultImpls.tsBridgeRecordRLCons(/* #__PURE__ */ TsBridge_Class.tsBridgeByTok(Ouroboros_Models_Brands_ErrorMessageText.tsBridgeErrorMessageText))(/* #__PURE__ */ TsBridge_DefaultImpls.tsBridgeRecordRLCons(/* #__PURE__ */ TsBridge_Class.tsBridgeByTok(/* #__PURE__ */ TsBridge_Class.tsBridgeMaybe(Ouroboros_Models_Brands_HttpStatusCode.tsBridgeHttpStatusCode)))(/* #__PURE__ */ TsBridge_DefaultImpls.tsBridgeRecordRLCons(/* #__PURE__ */ TsBridge_Class.tsBridgeByTok(TsBridge_Class.tsBridgeString))(TsBridge_DefaultImpls.tsBridgeRecordRLNil)({
    reflectSymbol: function () {
        return "type";
    }
}))({
    reflectSymbol: function () {
        return "statusCode";
    }
}))({
    reflectSymbol: function () {
        return "message";
    }
}))))(/* #__PURE__ */ TsBridge_Class.tsBridgeRecord(/* #__PURE__ */ tsBridgeRecord1(/* #__PURE__ */ TsBridge_DefaultImpls.tsBridgeRecordRLCons(/* #__PURE__ */ TsBridge_Class.tsBridgeByTok(Ouroboros_Models_Brands_JwtStatus.tsBridgeJwtStatus))(/* #__PURE__ */ TsBridge_DefaultImpls.tsBridgeRecordRLCons(/* #__PURE__ */ TsBridge_Class.tsBridgeByTok(Ouroboros_Models_Brands_JwtSubscriptionStatus.tsBridgeJwtSubscriptionSt))(TsBridge_DefaultImpls.tsBridgeRecordRLNil)({
    reflectSymbol: function () {
        return "subscription_status";
    }
}))({
    reflectSymbol: function () {
        return "status";
    }
})))))));
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var JwtSessionAction = function (x) {
    return x;
};
var tsBridgeJwtSessionAction = {
    tsBridge: function (v) {
        return bind(tsBridge(Type_Proxy["Proxy"].value))(function (valueType) {
            return pure(Ouroboros_Programs_TsBridgeHelpers.brandIntersection(valueType)("JwtSessionAction")("__brandJwtSessionAction"));
        });
    }
};
var runStorageSet = function (v) {
    return function (payload) {
        return v(payload);
    };
};
var runStorageRemove = function (v) {
    return function (key) {
        return v(key);
    };
};
var runStorageGet = function (v) {
    return function (key) {
        return v(key);
    };
};
var runNavigate = function (v) {
    return function (path) {
        return v(path);
    };
};
var runJwtRefreshIntent = Ouroboros_Programs_Capabilities.runRefreshIntent;
var runClockNow = function (v) {
    return v;
};
var runAction = function (v) {
    return v;
};
var readState = function (v) {
    return v;
};
var parseStoredTimestamp = /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.chain(function (value) {
    var v = Data_Int.fromString(value);
    if (v instanceof Data_Maybe.Just) {
        return Ouroboros_Services_Clients_Interop_Option.some(v.value0);
    };
    if (v instanceof Data_Maybe.Nothing) {
        return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
    };
    throw new Error("Failed pattern match at Ouroboros.Programs.Controllers.JwtSession (line 210, column 7 - line 212, column 36): " + [ v.constructor.name ]);
});
var mkJwtSessionAction = JwtSessionAction;
var mkJwtSessionController = function (env) {
    var withoutIntent = function (io) {
        return Ouroboros_Services_Clients_Interop_IO.map(function (v) {
            return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
        })(io);
    };
    var setSubscriptionStatus = Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(env.subscriptionStatus));
    var setRefreshDisabled = Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(env.refreshDisabled));
    var setLastRefreshAt = Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(env.lastRefreshAt));
    var readRefreshDisabled = readState(Ouroboros_Programs_Capabilities.stateHandleRead(env.refreshDisabled));
    var readLastRefreshAt = readState(Ouroboros_Programs_Capabilities.stateHandleRead(env.lastRefreshAt));
    var clearSession = Ouroboros_Services_Clients_Interop_IO.sequenceOk([ setLastRefreshAt(Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)), setSubscriptionStatus(Ouroboros_Models_Brands_JwtSubscriptionStatus.makeJwtSubscriptionStatus("not-found")), runStorageRemove(env.storageRemove)(env.refreshTimestampKey) ]);
    var markExpired = Ouroboros_Services_Clients_Interop_IO.map(function (v) {
        return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
    })(Ouroboros_Services_Clients_Interop_IO.sequenceOk([ runStorageSet(env.storageSet)({
        key: env.refreshDisabledKey,
        value: "true"
    }), setRefreshDisabled(true), clearSession ]));
    var refreshFromStorage = function (now) {
        return Ouroboros_Services_Clients_Interop_IO.chain(function (storedTimestamp) {
            return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
                return markExpired;
            })(function (timestamp) {
                var $72 = (now - timestamp | 0) > env.refreshWindowMs;
                if ($72) {
                    return markExpired;
                };
                return Ouroboros_Services_Clients_Interop_IO.pure(Ouroboros_Services_Clients_Interop_Option.some(env.refreshIntent));
            })(parseStoredTimestamp(storedTimestamp));
        })(runStorageGet(env.storageGet)(env.refreshTimestampKey));
    };
    var refreshIfNeeded = (function () {
        if (readRefreshDisabled) {
            return Ouroboros_Services_Clients_Interop_IO.pure(Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit));
        };
        return Ouroboros_Services_Clients_Interop_IO.chain(function (now) {
            return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
                return refreshFromStorage(now);
            })(function (lastRefreshAt) {
                var $74 = (now - lastRefreshAt | 0) < env.refreshCooldownMs;
                if ($74) {
                    return Ouroboros_Services_Clients_Interop_IO.pure(Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit));
                };
                return Ouroboros_Services_Clients_Interop_IO.pure(Ouroboros_Services_Clients_Interop_Option.some(env.refreshIntent));
            })(readLastRefreshAt);
        })(runClockNow(env.clockNow));
    })();
    var markUnauthorized = Ouroboros_Services_Clients_Interop_IO.sequenceOk([ runStorageSet(env.storageSet)({
        key: env.refreshDisabledKey,
        value: "true"
    }), setRefreshDisabled(true), clearSession, runNavigate(env.navigate)(env.loginRoute) ]);
    var acceptLoginStatus = function (status) {
        return Ouroboros_Services_Clients_Interop_IO.chain(function (now) {
            return Ouroboros_Services_Clients_Interop_IO.sequenceOk([ setRefreshDisabled(false), setSubscriptionStatus(status), setLastRefreshAt(Ouroboros_Services_Clients_Interop_Option.some(now)), runStorageSet(env.storageSet)({
                key: env.refreshTimestampKey,
                value: show(now)
            }), runStorageRemove(env.storageRemove)(env.refreshDisabledKey) ]);
        })(runClockNow(env.clockNow));
    };
    return {
        acceptLoginStatus: function (status) {
            return mkJwtSessionAction(withoutIntent(acceptLoginStatus(status)));
        },
        refreshIfNeeded: mkJwtSessionAction(refreshIfNeeded),
        markUnauthorized: mkJwtSessionAction(withoutIntent(markUnauthorized)),
        clearSession: mkJwtSessionAction(withoutIntent(clearSession))
    };
};
var mkJwtRefreshIntent = Ouroboros_Programs_Capabilities.mkRefreshIntent;
var documentationPath = "/documentation/drafting/frontend-program-builder/controllers/jwt_session_controller.md";
var actionEffect = function (action) {
    return Ouroboros_Services_Clients_Interop_IO.map(function (v) {
        return Ouroboros_Models_Core_Ok.ok;
    })(runAction(action));
};
var runJwtRefreshIfNeeded = function (controller) {
    return Ouroboros_Services_Clients_Interop_Task.chain(function (intentOption) {
        return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return Ouroboros_Services_Clients_Interop_Task.pure(Ouroboros_Models_Core_Ok.ok);
        })(function (intent) {
            return Ouroboros_Services_Clients_Interop_TaskEither.fold(function (v) {
                return Ouroboros_Services_Clients_Interop_Task.fromIO(actionEffect(controller.markUnauthorized));
            })(function (response) {
                return Ouroboros_Services_Clients_Interop_Task.fromIO(actionEffect(controller.acceptLoginStatus(response.subscription_status)));
            })(runJwtRefreshIntent(intent));
        })(intentOption);
    })(Ouroboros_Services_Clients_Interop_Task.fromIO(runAction(controller.refreshIfNeeded)));
};
export {
    JwtSessionAction,
    mkJwtRefreshIntent,
    runJwtRefreshIntent,
    runJwtRefreshIfNeeded,
    actionEffect,
    mkJwtSessionController,
    documentationPath,
    tsBridgeJwtSessionAction
};
//# sourceMappingURL=index.js.map
